module.exports = __webpack_public_path__ + "img/shield1.db3f1572.png";